import { createAsyncThunk } from '@reduxjs/toolkit';
import RootState from "../states/root.state";
import { assignUserGroupPermissionsApi, assignUserGroupUsersApi, deleteUserGroupApi, getUserGroup, getUserGroupPermissions, getUserGroups, getUserGroupUsers, getUserGroupUsersByEmail, putUserGroup, removeUserGroupPermissionsApi, removeUserGroupUsersApi } from '../../services/api/userGroups.api';
import User from '../models/user.model';
import { Permission } from '../models/permission.model';

export const fetchUserGroups = createAsyncThunk<any, string, { rejectValue: string; state: RootState}>(
    'user-groups',
    async (params, {rejectWithValue, getState}) => {
        try {
        const {user} = getState();
        const token = user.accessToken;

        const response = await getUserGroups(token, params);
        return response.data;

        } catch (error: any) {
            if (error.response) {
                return rejectWithValue(error.response.data.data.message??error.response.data.message??"An error occurred while fetching user groups.");
            } else {
                return rejectWithValue('An error occurred while fetching user groups.');
            }
        }
    }
);

export const fetchUserGroup = createAsyncThunk<any, string, { rejectValue: string; state: RootState}>(
    'user-group',
    async (id, {rejectWithValue, getState}) => {

    try {
        const {user} = getState();
        const token = user.accessToken;

        const response = await getUserGroup(token, id);
        return response.data;

        } catch (error: any) {
            if (error.response) {
                return rejectWithValue(error.response.data.data.message??error.response.data.message??"An error occurred while fetching user group.");
            } else {
                return rejectWithValue('An error occurred while fetching user group.');
            }
        }
    }
);

export const fetchUserGroupUsers = createAsyncThunk<any, {id:string, params:string}, { rejectValue: string; state: RootState}>(
    'user-group/users',
    async (getInfo, {rejectWithValue, getState}) => {
        try {
            const {user} = getState();
            const token = user.accessToken;

            const response = await getUserGroupUsers(token, getInfo);
            return response.data;

            } catch (error: any) {
                if (error.response) {
                    return rejectWithValue(error.response.data.data.message??error.response.data.message??"An error occurred while fetching user group users.");
                } else {
                    return rejectWithValue('An error occurred while fetching user group users.');
                }
            }
    }
);

export const fetchUserGroupUsersByEmail = createAsyncThunk<any, {id:string, params:string}, { rejectValue: string; state: RootState}>(
    'user-group/users-by-email',
    async (getInfo, {rejectWithValue, getState}) => {
        try {
            const {user} = getState();
            const token = user.accessToken;

            const response = await getUserGroupUsersByEmail(token, getInfo);
            return response.data;

        } catch (error: any) {
            if (error.response) {
                return rejectWithValue(error.response.data.data.message??error.response.data.message??"An error occurred while fetching user group users by email.");
            } else {
                return rejectWithValue('An error occurred while fetching user group users by email.');
            }
        }
    }
);

export const updateUserGroup = createAsyncThunk<any, {id:string, name:string, description:string}, { rejectValue: string; state: RootState}>(
    'user-group/update',
    async (updateInfo, {rejectWithValue, getState}) => {
        try {
            const {user} = getState();
            const token = user.accessToken;

            const response = await putUserGroup(token, updateInfo);

            return response.data;

        } catch (error: any) {
            if (error.response) {
                return rejectWithValue(error.response.data.data.message??error.response.data.message??"An error occurred while updating user group.");
            } else {
                return rejectWithValue('An error occurred while updating user group.');
            }
        }
    } 

);

export const deleteUserGroup = createAsyncThunk<any, {id:string}, { rejectValue: string; state: RootState}>(
    'user-groups/delete',
    async (deleteInfo, {rejectWithValue, getState}) => {
        try {
            const {user} = getState();
            const token = user.accessToken;

            const response = await deleteUserGroupApi(token, deleteInfo.id);
            return response.data;

        } catch (error: any) {
            if (error.response) {
                return rejectWithValue(error.response.data.data.message??error.response.data.message??"An error occurred while deleting user group.");
            } else {
                return rejectWithValue('An error occurred while deleting user group.');
            }
        }
    } 
);

export const assignUserGroupUsers = createAsyncThunk<any, {id:string, users:User[]}, { rejectValue: string; state: RootState}>(
    'user-group/assign-users',
    async (updateInfo, {rejectWithValue, getState}) => {
        try {
            const {user} = getState();
            const token = user.accessToken;

            const response = await assignUserGroupUsersApi(token, updateInfo);
            return response.data;

        } catch (error: any) {
            if (error.response) {
                return rejectWithValue(error.response.data.data.message??error.response.data.message??"An error occurred while assigning user group users.");
            } else {
                return rejectWithValue('An error occurred while assigning user group users.');
            }
        }
    } 
);


export const removeUserGroupUsers = createAsyncThunk<any, {id:string, users:User[]}, { rejectValue: string; state: RootState}>(
    'user-group/remove-users',
    async (updateInfo, {rejectWithValue, getState}) => {
        try {
            const {user} = getState();
            const token = user.accessToken;

            const response = await removeUserGroupUsersApi(token, updateInfo);
            return response.data;

        } catch (error: any) {
            if (error.response) {
                return rejectWithValue(error.response.data.data.message??error.response.data.message??"An error occurred while removing user group users.");
            } else {
                return rejectWithValue('An error occurred while removing user group users.');
            }
        }
    } 
);


export const assignUserGroupPermissions = createAsyncThunk<any, {id:string, permissions:Permission[]}, { rejectValue: string; state: RootState}>(
    'user-group/assign-permissions',
    async (updateInfo, {rejectWithValue, getState}) => {
        try {
            const {user} = getState();
            const token = user.accessToken;

            const response = await assignUserGroupPermissionsApi(token, updateInfo);
            return response.data;

        } catch (error: any) {
            if (error.response) {
                return rejectWithValue(error.response.data.data.message??error.response.data.message??"An error occurred while assigning user group permissions.");
            } else {
                return rejectWithValue('An error occurred while assigning user group permissions.');
            }
        }
    } 
);

export const removeUserGroupPermissions = createAsyncThunk<any, {id:string, permissions:Permission[]}, { rejectValue: string; state: RootState}>(
    'user-group/remove-permissions',
    async (updateInfo, {rejectWithValue, getState}) => {
        try {
            const {user} = getState();
            const token = user.accessToken;

            const response = await removeUserGroupPermissionsApi(token, updateInfo);
            return response.data;

        } catch (error: any) {
            if (error.response) {
                return rejectWithValue(error.response.data.data.message??error.response.data.message??"An error occurred while removing user group permissions.");
            } else {
                return rejectWithValue('An error occurred while removing user group permissions.');
            }
        }
    } 
);

export const fetchUserGroupPermissions = createAsyncThunk<any, {id:string, params:string}, { rejectValue: string; state: RootState}>(
    'user-group/permissions',
    async (getInfo, {rejectWithValue, getState}) => {
        try {
            const {user} = getState();
            const token = user.accessToken;

            const response = await getUserGroupPermissions(token, getInfo);
            return response.data;

        } catch (error: any) {
            if (error.response) {
                return rejectWithValue(error.response.data.data.message??error.response.data.message??"An error occurred while fetching user group permissions.");
            } else {
                return rejectWithValue('An error occurred while fetching user group permissions.');
            }
        }
    }
);
